import React, { useContext, useEffect, useRef, useState } from "react";

import LegajoContext from '../../context/legajoContext/legajoContex.js';

import './ImputacionRRHHSubtabla.css';
import SelectControl from "../SelecControl/SelectControl.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackspace } from "@fortawesome/free-solid-svg-icons";
import categoriasRRHHContext from "../../context/categoriasRRHHContext/categoriasRRHHContex.js";

//Remover luego =[]
const ImputacionRRHHSubtabla = ({imputaciones = [], tablaSeleccionada, handleChangeImputaciones, handleDeleteImputaciones, tipo, componentePadre}) =>{

    const lContext = useContext(LegajoContext);
    const {legajosList} = lContext;
    const rrhhContext = useContext(categoriasRRHHContext);
    const [legajosOptions, setLegajosOptions] = useState([]);
    const {categoriasRRHHList} = rrhhContext;
    const containerRef = useRef(null);

    useEffect(()=>{
        if(Array.isArray(legajosList) && legajosList.length > 0 && Array.isArray(categoriasRRHHList) && categoriasRRHHList.length > 0){
            let legajos = [...legajosList];
            legajos = legajos.map((l,i) => {
                let cat = categoriasRRHHList.find((c) => c._id == l.categoriaID);
                let legajoModelado = {
                    id:l._id, value:l.codigo, label:l.nombre, catego:l.catego, basico: (cat != undefined) ? cat.basico : 0, adicional: (cat != undefined) ? cat.adicional : 0, basicoHora: (cat != undefined) ? cat.basicoHora : 0
                }
                return legajoModelado;
            })
            setLegajosOptions(legajos);
        }

    },[legajosList, categoriasRRHHList]);

    useEffect(()=>{
        containerRef.current?.scrollTo({top: containerRef.current.scrollHeight, behavior: 'smooth'});
    },[imputaciones?.length])

    return <div className={`${tablaSeleccionada != 'imputaciones' && 'inactive'} imputacionesRRHHDiv`}>
        <div className="subtablaHeaderLabel">
            <label>Imputaciones por {componentePadre == 'Activo' ? 'Activo' : componentePadre == 'FormReq' ? 'Orden de Trabajo' : 'Procedimiento'}</label> 
        </div>
        <div className={`headerSubtabla`}>
            <label></label>
            <label>Legajo</label>
            <label>Cantidad en Horas</label>
            <label>Texto Adicional</label>
        </div>
        <div className="bodyTable" ref={containerRef}>
            {(imputaciones != undefined && imputaciones.length > 0) && imputaciones.map((i, index) => <div className="rrCategoriasAsociadas" key={index}>
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteImputaciones(i,index)} />
                <SelectControl placeholder={"Seleccione un legajo..."} modo={"Nuevo"} handleChengeSelect={handleChangeImputaciones} optionsSelect={legajosOptions} valueSeleccionada={i.legajo} tipo={'imputacionRRHH'} propToChange="legajo" selectSelect={handleChangeImputaciones} index={index}/>
                <input value={i.cantHoras} onChange={(e) => handleChangeImputaciones({},index,'cantHoras',e.target.value)} type="number"/>
                <input value={i.textAdic} onChange={(e) => handleChangeImputaciones({},index,'textAdic',e.target.value)}/>
            </div>)}
        </div>
    </div>
}

export default React.memo(ImputacionRRHHSubtabla);